import React, { PureComponent } from 'react'
import { Tooltip, OverlayTrigger, Button, Form } from 'react-bootstrap'
import { Field, reduxForm, reset } from 'redux-form'
import { fromCamelToUnderscore, convertStringToDate, convertUTCDateToLocalDate, getDateNowMaxDatePicker, formatDate, handleKeyDown } from '../../util/utils'
import SimpleTablePage from '../../containers/commons/general/SimpleTablePage'
import IDocCarPagination from '../../components/commons/iDocCarPagination'
import { validateDate } from '../../util/validationFunctions'
import { dossierTypesId } from '../../constants/dossier/common/dossierTypes'
import { permissions } from '../../constants/backendIds'
import { getSectionPermissions, getFieldsSectionPermissions } from '../../util/permisionFunctions'
import { sectionPermissions } from '../../constants/dossier/common/buttonsHeader'
import MapSectionsManagement from '../../util/map-sections-management'
import InputText from '../../components/commons/form/InputText'
import InputSelect from '../../components/commons/form/InputSelect'
import InputTreeSelect from '../../components/commons/form/InputTreeSelect'
import InputDatePicker from '../../components/commons/form/InputDatePicker'
import { showFilter, hideFiltersBtn, toggleFilterClass, getIconClass } from '../../util/management/ManagementUtils'
import { Link } from 'react-router-dom'

class FleetsManager extends PureComponent {
  constructor () {
    super()
    this.state = {
      fields: [],
      filters: [],
      dynamicFilters: [],
      disableResetButton: false,
      displayBar: 'none',
      progress: 0,
      progressFail: 0,
      errors: [],
      maxBar: 0,
      showModalObservations: false,
      observations: '',
      showModalCreate: false,
      showModalOperate: false,
      fieldsConfiguration: {
        createFleet: { permission: null },
        editFleet: { permission: null },
        operateFleet: { permission: null },
        economicFleet: { permission: null },
        documentsFleet: { permission: null },
        viewFleet: { permission: null },
        deleteFleet: { permission: null },
        codeCommission: { permission: null },
        addOtherDocumentsFleet: { permission: null }
      },
      maxiTable: false,
      hideFilters: false
    }
  }

  initializePermisions (props) {
    const section = props.sectionsGeneral.filter((tabConf) => tabConf.code === sectionPermissions.management)
    if (section.length > 0 && section[0] != null) {
      const newState = getSectionPermissions(section[0])
      let permissionState = this.state.sectionTabsConfiguration
      permissionState = { ...permissionState, ...newState }
      if (permissionState.fleet_management_section && permissionState.fleet_management_section.sectionFieldsConfiguration) {
        const fieldKeys = Object.keys(this.state.fieldsConfiguration)
        const permission = getFieldsSectionPermissions(permissionState.fleet_management_section.sectionFieldsConfiguration, fieldKeys, permissions.hidden)
        this.setState({ fieldsConfiguration: permission.fieldsConfiguration })
      }
    }
  }

  componentDidMount () {
    this.initializePermisions(this.props)
    this.props.actions.initializeSearch()
    if (this.props.dynamicFilters && typeof this.props.dynamicFilters === 'object' && Object.keys(this.props.dynamicFilters).length > 0) {
      const fieldsToFill = {}
      let originalKey
      Object.entries(this.props.dynamicFilters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          originalKey = key
          if (key === 'organizedUnits') {
            key = 'organizedUnit'
          }
          if (value instanceof Date) {
            value = formatDate(value)
          }
          this.props.change(key, value)
          fieldsToFill[originalKey] = value
        }
      })
      this.setState({
        fields: {
          ...this.state.fields,
          ...fieldsToFill
        },
        hideFilters: true
      }, () => {
        this.fetchTable()
      })
    }
    this.props.actions.fetchDossierSubTypes(null, dossierTypesId.sales)
    this.props.actions.fetchOrganizedUnitsAcceptClientsCombo()
    this.props.actions.fetchOrganizedUnitsCombo()
  }

  submitSearchForm () {
    this.fetchTable()
  }

  fieldFill (field) {
    this.setState({ fields: { ...this.state.fields, ...field } })
  }

  extractMultipleComboStringArray (combo, filters, item) {
    let array = filters[item] ? filters[item].split(',').map(Number) : null
    const values = combo.filter(object => {
      return array ? array.some(selectedComboValue => object.id === selectedComboValue) : null
    })

    let value = values && this.formatMultipleValues(values)
    return value
  }

  formatMultipleValues (multiplecombovalues) {
    return multiplecombovalues
      .map((combovalue, index) => combovalue.value)
      .join(', ')
  }

  treeComboToArray (combo) {
    var values = []
    combo.map((item, index) => {
      values.push({ id: item.value, value: item.label })
      if (item.children && item.children.length > 0) {
        values = values.concat(this.treeComboToArray(item.children))
      }
    })
    return values
  }

  selectedFilters () {
    const filters = this.props.dynamicFilters
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    return Object.keys(filters)
      .map((item, index) => {
        let text = item
        let value = null
        const list = []

        switch (item) {
          case 'organizedUnits':
          {
            value = this.extractMultipleComboStringArray(this.treeComboToArray(this.props.combos.UOTreeCombo), filters, item)
            text = this.props.t(`${tKey}${'ORGANIZED_UNIT'}`)
            break }
          case 'dossierSubtypeId':
          { const selectedSubtype = this.props.combos.dossierSubTypesCombo.find(subtype => subtype.id === filters[item])
            text = this.props.t(`${tKey}${fromCamelToUnderscore('dossierSubtype').toUpperCase()}`)
            value = selectedSubtype && selectedSubtype.value
            break }
          default:
          {
            if (filters[item] instanceof Date) {
              value = formatDate(filters[item])
            } else {
              value = filters[item]
            }

            if (value) {
              text = this.props.t(`${tKey}${fromCamelToUnderscore(item).toUpperCase()}`)
            }
            break }
        }
        if (value) {
          list.push(<li key={'filter_' + index}>{text}: <strong>{value}</strong></li>)
        }

        return list
      })
  }

  onClickResetSearch (e) {
    if (e !== undefined) {
      e.preventDefault()
    }

    this.props.actions.modifyFleetManagementFilters()
  }

  handleClickReset (e) {
    if (e !== undefined) {
      e.preventDefault()
    }
    this.clearFields()
    this.props.actions.resetFleetManagementFilters()
    this.props.dispatch(reset('fleetsManager'))
  }

  exportData () {
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    let columnsExcel = []

    columnsExcel.push(this.props.t(`${tKey}CODE`))
    columnsExcel.push(this.props.t(`${tKey}DESCRIPTION`))
    columnsExcel.push(this.props.t(`${tKey}ORGANIZEDUNIT`))
    columnsExcel.push(this.props.t(`${tKey}DOSSIER_SUBTYPE`))
    columnsExcel.push(this.props.t(`${tKey}CLIENT`))
    columnsExcel.push(this.props.t(`${tKey}CREATION_DATE`))
    columnsExcel.push(this.props.t(`${tKey}NUM_DOSSIERS`))

    let cols = columnsExcel.join('$')

    let data = { userId: null, languageId: null, ...this.props.dynamicFilters, Columns: cols }
    this.props.actions.exportFleetsManagement(data, this.props.filters)
  }

  onOrderChange (e) {
    const newOrderBy = this.props.filters.orderBy.includes(`+${e.currentTarget.dataset.field}`) ? `-${e.currentTarget.dataset.field}` : `+${e.currentTarget.dataset.field}`
    this.fetchTable({ ...this.props.filters, orderBy: newOrderBy })
  }

  onPageChange (page) {
    this.fetchTable({ ...this.props.filters, page })
  }

  haveValues (fields) {
    for (let key in fields) {
      if (fields[key] !== null && fields[key] !== undefined && fields[key] !== '') {
        return true
      }
    }
    return false
  }

  fetchTable (filters) {
    let filtersToSend = filters || this.props.filters
    if (!this.haveValues(this.state.fields)) {
      this.props.actions.openModal('mustFillFilters')
    } else {
      let data = { userId: null, languageId: null, ...this.state.fields }
      data = this.setDataDates(data)
      this.props.actions.fetchFleetsManagement(data, filtersToSend)
      this.setState({ hideFilters: true })
    }
  }

  setDataDates (data) {
    if (data.creationDateFrom) {
      data.creationDateFrom = convertUTCDateToLocalDate(convertStringToDate(data.creationDateFrom))
    }
    if (data.creationDateTo) {
      data.creationDateTo = convertUTCDateToLocalDate(convertStringToDate(data.creationDateTo))
    }
    if (data.renewalDateFrom) {
      data.renewalDateFrom = convertUTCDateToLocalDate(convertStringToDate(data.renewalDateFrom))
    }
    if (data.renewalDateTo) {
      data.renewalDateTo = convertUTCDateToLocalDate(convertStringToDate(data.renewalDateTo))
    }
    return data
  }

  clearFields () {
    this.setState({ fields: {} })
  }

  validateDate (value, allValues, props) {
    const result = validateDate(value, props)
    return result === Object(result) ? undefined : result
  }

  historical (row) {
    new Promise((resolve) => {
      this.props.actions.getFleetModel(row.fleetId, resolve)
    }).then((response) => {
      this.setState({ showModalCreate: true })
      this.props.actions.showHistoricalFleetModal(true, response)
    })
  }

  toogleHideFilters () {
    this.setState({ hideFilters: !this.state.hideFilters })
  }

  toogleMaxiTable () {
    this.setState({ maxiTable: !this.state.maxiTable })
  }

  render () {
    const {
      t, className, /* classNameSelect, */ count, fleetsData, filters: { page, pages }, handleSubmit, hasSearch, combos: { dossierSubTypesCombo, UOTreeCombo }
    } = this.props
    const secMapManagement = MapSectionsManagement.find(function (s) { return s.page === 'fleetsManagerPage' })
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    const dKey = 'GLOBAL.TABLES.'
    const hideInnerMenu = (<Tooltip id="editProductTooltip">{`${t(dKey + (this.props.hideMenu ? 'SHOW_INNER_MENU' : 'HIDE_INNER_MENU'))}`}</Tooltip>)
    const hasResults = fleetsData && fleetsData.length > 0
    return (
      <>
        <div id='fleetsManager' className="inner-results-panel">
          <div className="section-results-header">
            <div className="section-header-title">
              <OverlayTrigger placement="right" overlay={hideInnerMenu}>
                <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
              </OverlayTrigger>
              <h4 className={'hasFilters' + hideFiltersBtn(hasResults)} onClick={() => this.toogleHideFilters()}>{t(`${secMapManagement.title}`)}
                <OverlayTrigger placement="left" overlay={<Tooltip id="editProductTooltip">{`${t((this.state.hideFilters ? 'GLOBAL.TABLES.SHOW_FILTERS' : 'GLOBAL.TABLES.HIDE_FILTERS'))}`}</Tooltip>}>
                  <a onClick={() => this.toogleHideFilters()} className={'toogleShowFilters ' + hideFiltersBtn(hasResults)}><i className={toggleFilterClass(hasResults, this.state.hideFilters)}></i></a>
                </OverlayTrigger>
              </h4>
              {this.state.fieldsConfiguration.createFleet && this.state.fieldsConfiguration.createFleet.permission === permissions.editable && (
                <Link to={'/fleet/-1'} className="_Btn new"><i className="iDocIcon-file-fleets"></i>{t(`${tKey}CREATE_NEW_FLEET`)}</Link>
              )}
            </div>
            <Form autoComplete="off" onSubmit={handleSubmit((values) => this.submitSearchForm(values))} onKeyDown={(e) => handleKeyDown(e) } className="">
              <div className={'search-form ' + (showFilter(hasResults, this.state.hideFilters) ? '' : 'hideFilters ')}>
                <Field
                  component={InputText}
                  colWidth={25} // 25, 33, 50, 75, 100 default=25
                  id="fleetSearch_fleetCode"
                  className="myClass"
                  name='fleetCode'
                  placeholder={t(`${tKey}CODE`)}
                  controlLabel={t(`${tKey}CODE`)}
                  type="text"
                  onInputChange={(val) => this.fieldFill({ fleetCode: val })}
                  customClass={this.state.fields.fleetCode ? className : ''}
                />
                <Field
                  component={InputTreeSelect}
                  colWidth={25} // 25, 33, 50, 75, 100 default=25
                  id="fleetSearch_organizedUnit"
                  name='organizedUnit'
                  placeholder={t(`${tKey}ORGANIZED_UNIT`)}
                  controlLabel={t(`${tKey}ORGANIZED_UNIT`)}
                  onInputChange={(val) => this.fieldFill({ organizedUnits: val })}
                  multi={true}
                  valueKey="value"
                  labelKey="label"
                  childrenKey="children"
                  options={UOTreeCombo}
                />
                <Field
                  component={InputSelect}
                  colWidth={25} // 25, 33, 50, 75, 100 default=25
                  id="fleetSearch_dossierSubtypeId"
                  name='dossierSubtypeId'
                  placeholder={t(`${tKey}DOSSIER_SUBTYPE`)}
                  controlLabel={t(`${tKey}DOSSIER_SUBTYPE`)}
                  sm={''}
                  options={dossierSubTypesCombo}
                  valueKey="id"
                  labelKey="value"
                  onInputChange={ (val) => { this.fieldFill({ dossierSubtypeId: val }) } }
                />
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="fleetSearch_client"
                  name='client'
                  placeholder={t(`${tKey}CLIENT`)}
                  controlLabel={t(`${tKey}CLIENT`)}
                  onInputChange={(val) => this.fieldFill({ client: val })}
                />
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="fleetSearch_finalClient"
                  name='finalClient'
                  placeholder={t(`${tKey}FINAL_CLIENT`)}
                  controlLabel={t(`${tKey}FINAL_CLIENT`)}
                  onInputChange={(val) => this.fieldFill({ finalClient: val })}
                />
                <Field
                  component={InputDatePicker}
                  colWidth={25} // 25, 33, 50, 75, 100 default=25
                  id="fleetSearch_creationDateFrom"
                  name='creationDateFrom'
                  placeholder={t(`${tKey}CREATION_DATE_FROM`)}
                  controlLabel={t(`${tKey}CREATION_DATE_FROM`)}
                  validate={[this.validateDate]}
                  onInputChange={(val) => this.fieldFill({ creationDateFrom: val })}
                  maxDate={getDateNowMaxDatePicker()}
                />
                <Field
                  component={InputDatePicker}
                  colWidth={25} // 25, 33, 50, 75, 100 default=25
                  id="fleetSearch_creationDateTo"
                  name='creationDateTo'
                  placeholder={t(`${tKey}CREATION_DATE_TO`)}
                  controlLabel={t(`${tKey}CREATION_DATE_TO`)}
                  validate={[this.validateDate]}
                  onInputChange={(val) => this.fieldFill({ creationDateTo: val })}
                  maxDate={getDateNowMaxDatePicker()}
                />
                <Field
                  component={InputDatePicker}
                  colWidth={25} // 25, 33, 50, 75, 100 default=25
                  id="fleetSearch_renewalDateFrom"
                  name='renewalDateFrom'
                  placeholder={t(`${tKey}RENEWAL_DATE_FROM`)}
                  controlLabel={t(`${tKey}RENEWAL_DATE_FROM`)}
                  validate={[this.validateDate]}
                  onInputChange={(val) => this.fieldFill({ renewalDateFrom: val })}
                />
                <Field
                  component={InputDatePicker}
                  colWidth={25} // 25, 33, 50, 75, 100 default=25
                  id="fleetSearch_renewalDateTo"
                  name='renewalDateTo'
                  placeholder={t(`${tKey}RENEWAL_DATE_TO`)}
                  controlLabel={t(`${tKey}RENEWAL_DATE_TO`)}
                  validate={[this.validateDate]}
                  onInputChange={(val) => this.fieldFill({ renewalDateTo: val })}
                />
                <div className='search-form-actions flexInLine al-R'>
                  <Button id="fleetSearch_btn_search"
                    type="submit"
                    className="_Btn accept">
                    <i className="iDocIcon-search"/>
                    {t('SEARCH.ACTIONS.SEARCH_BUTTON')}
                  </Button>
                  <Button
                    id="fleetSearch_btn_reset"
                    onClick={(e) => this.handleClickReset(e)}
                    className={'_Btn stk' + (this.props.pristine ? ' accept' : ' accept')}
                    disabled={this.props.pristine}
                  >
                    <i className="iDocIcon-clear-decline"/> {t('SEARCH.ACTIONS.RESET_BUTTON')}
                  </Button>
                  { hasSearch && count > 0 &&
                    <Button id="fleetSearch_btn_export"
                      className="_Btn new o-icn"
                      onClick={(event) => this.exportData(event)}>
                      <i className="iDocIcon-file-excel"/>
                      {t('SEARCH.ACTIONS.EXPORT')}
                    </Button>
                  }
                </div>
              </div>
            </Form>
          </div>
          <div className="section-results-body">
            <div className={'searchResoultsContainer' + (this.state.maxiTable ? ' maxiTable' : '')}>
              {hasSearch && ([
                <div className="table-wrapper fleets" key="fleetResult_table-wrapper">
                  <ul className="list-inline"> {/* Active filter list */}
                    {this.selectedFilters().length === 0 ? <li>{t(`${tKey}NO_SELECTED_FILTERS`)}</li> : (this.selectedFilters())}
                  </ul>
                  {/* table options, maximize, etc.... */}
                  {hasResults &&
                  <div className='flexInLine al-R'>
                    <OverlayTrigger placement="left" overlay={<Tooltip id="editProductTooltip">{`${t(dKey + (this.state.maxiTable ? 'MINIMIZE_TABLE' : 'MAXIMIZE_TABLE'))}`}</Tooltip>}>
                      <a onClick={() => this.toogleMaxiTable()} className='_Btn accept stk o-icn maximizeBtn'><i className={(this.state.maxiTable ? 'iDocIcon-Minimize' : 'iDocIcon-Maximize')}></i></a>
                    </OverlayTrigger>
                  </div>}
                  {/* table */}
                  {hasResults ? [

                    <div className="table-responsive" key="fleetResult_table-responsive">
                      <SimpleTablePage
                        columns={[
                          <th key={0} data-field="fleetNumber" onClick={(event) => this.onOrderChange(event)}>
                            {t(`${tKey}FLEET_NUMBER`)}&nbsp;<i className={getIconClass('fleetNumber', this.props.filters)}></i>
                          </th>,
                          <th key={1} data-field="fleetCode" onClick={(event) => this.onOrderChange(event)}>
                            {t(`${tKey}CODE`)}&nbsp;<i className={getIconClass('fleetCode', this.props.filters)}></i>
                          </th>,
                          <th key={2} data-field="description" onClick={(event) => this.onOrderChange(event)}>
                            {t(`${tKey}DESCRIPTION`)}&nbsp;<i className={getIconClass('description', this.props.filters)}></i>
                          </th>,
                          <th key={3} data-field="organizedUnit" onClick={(event) => this.onOrderChange(event)}>
                            {t(`${tKey}ORGANIZEDUNIT`)}&nbsp;<i className={getIconClass('organizedUnit', this.props.filters)}></i>
                          </th>,
                          <th key={4} data-field="clientName" onClick={(event) => this.onOrderChange(event)}>
                            {t(`${tKey}CLIENT`)}&nbsp;<i className={getIconClass('clientName', this.props.filters)}></i>
                          </th>,
                          <th key={5} data-field="dossierSubtype" onClick={(event) => this.onOrderChange(event)}>
                            {t(`${tKey}DOSSIER_SUBTYPE`)}&nbsp;<i className={getIconClass('dossierSubtype', this.props.filters)}></i>
                          </th>,
                          <th key={6} data-field="creationDate" onClick={(event) => this.onOrderChange(event)}>
                            {t(`${tKey}CREATION_DATE`)}&nbsp;<i className={getIconClass('creationDate', this.props.filters)}></i>
                          </th>,
                          <th key={7} data-field="dossiers" onClick={(event) => this.onOrderChange(event)}>
                            {t(`${tKey}NUM_DOSSIERS`)}&nbsp;<i className={getIconClass('dossiers', this.props.filters)}/>
                          </th>,
                          <th key={8} data-field="actions">{t(`${tKey}ACTIONS`)}&nbsp;</th>
                        ]}
                        rows={fleetsData && fleetsData.map((row, idx) => (
                          <tr key={'row_' + idx}>
                            <td>
                              <Link to={`/fleet/${row.fleetId}`}><span>{row.fleetNumber}</span></Link>
                            </td>
                            <td>
                              {row.fleetCode}
                            </td>
                            <td>
                              {row.description}
                            </td>
                            <td>
                              {row.organizedUnit}
                            </td>
                            <td>
                              {row.clientName}
                            </td>
                            <td>
                              {row.dossierSubtype}
                            </td>
                            <td>
                              {row.creationDate}
                            </td>
                            <td>
                              {row.dossiers}
                            </td>
                            <td className="actionsMenu see-more">
                              <Link to={`/fleet/${row.fleetId}`}><i className="iDocIcon-open-in-new-black"></i></Link>
                            </td>
                          </tr>
                        ))}
                      />
                    </div>,
                    <div className="search-footer" key="fleetResult_search-footer">
                      <IDocCarPagination
                        id="fleetResult_btn_pag_sales"
                        page={page}
                        pagesCount={pages}
                        totalRows= {count}
                        onSelectAction={(page) => this.onPageChange(page)}
                      />
                    </div>]
                    : <p className="no_results">{t('GLOBAL.TABLES.NO_RESULTS')}</p>}
                </div>
              ])}
            </div>

          </div>
        </div>
      </>
    )
  }
}

const validate = (values, { t }, props) => {
  const errors = {}

  if (values && values.creationDateFrom && values.creationDateTo) {
    let dateTo = convertStringToDate(values.creationDateTo)
    let dateFrom = convertStringToDate(values.creationDateFrom)
    if (dateFrom > dateTo) {
      errors.creationDateTo = t('GLOBAL.FORMS.DATE_TO_NOT_LESS_THAN_DATE_FROM')
    }
  }

  if (values && values.renewalDateFrom && values.renewalDateTo) {
    let dateTo = convertStringToDate(values.renewalDateTo)
    let dateFrom = convertStringToDate(values.renewalDateFrom)
    if (dateFrom > dateTo) {
      errors.renewalDateTo = t('GLOBAL.FORMS.DATE_TO_NOT_LESS_THAN_DATE_FROM')
    }
  }

  return errors
}

export default reduxForm({
  form: 'fleetsManager',
  validate,
  destroyOnUnmount: false
})(FleetsManager)
